import useMultipartMutation from './useMultipartMutation';

const useCreateEvent = () => useMultipartMutation<FormData, { message: string }>({
    method: 'POST',
    pathname: '/events',
});

export default useCreateEvent;
